import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { t } from '../../../../locales';
import { isApp, hideBackButton } from '../../../../utils/';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { getLanguage } from '../../../../selectors/userSelectors';
import EmmaNavTitle from '../../../../components/EmmaNavTitle';
import { ENTITY_CODE } from '../../../../constants/constants';
import './style.scss';
import { controlTopBar, showTopbar } from '../../../../utils/AppUtils';
import { goto } from '../../../../actions/historyActions';

const SUPPORT_CONTACT = {
  HK: {
    regionText: t('REGION_HONG_KONG'),
    phone: {
      text: '(852) 2802 2812',
      link: 'tel:+85228022812',
    },
    email: {
      text: 'cs@axa.com.hk',
      link: 'mailto:cs@axa.com.hk',
    },
    url: {
      en: 'https://www.axa.com.hk/en/axa-goal-support',
      zh: 'https://www.axa.com.hk/zh/axa-goal-support',
    },
  },
  MACAU: {
    regionText: t('REGION_MACAU'),
    phone: {
      text: '(853) 8799 2812',
      link: 'tel:+85387992812',
    },
    email: {
      text: 'ma.enquiry@axa.com.mo',
      link: 'mailto:ma.enquiry@axa.com.mo',
    },
  },
};

interface SupportProps {
  type: 'axa-goal' | 'my-wellness';
  ruleType?: 'WGP' | 'SH';
  lang: string;
  match?: {
    params?: {
      entityCode?: string;
    };
  };
}

interface SupportState {}

class Support extends Component<
  SupportProps & RouteComponentProps,
  SupportState
> {
  goToPage(item: any) {
    const { link } = item;
    link &&
      EmmaFactory.createInstance().then((e) => {
        e.instance && e.instance.goTo && e.instance.goTo(link);
      });
  }

  componentDidMount() {
    if (isApp()) {
      showTopbar();
      controlTopBar(true);
    }
  }

  renderContactSession(contactObj: any, lang: string) {
    const { type } = this.props;
    return (
      <div>
        <div className="axa-goal-support-help-link-wrap">
          <div className="axa-goal-support-help">{contactObj.regionText}</div>
        </div>
        <div className="axa-goal-support-help-link-wrap">
          <a
            href={contactObj.phone.link}
            className="axa-goal-support-help-link"
          >
            {contactObj.phone.text}​
          </a>
        </div>
        <div className="axa-goal-support-help-link-wrap">
          <a
            href={contactObj.email.link}
            target="_blank"
            rel="noopener noreferrer"
            className="axa-goal-support-help-link"
          >
            {contactObj.email.text}
          </a>
        </div>
        {contactObj.url && contactObj.url[lang] && type === 'axa-goal' && (
          <div className="axa-goal-support-help-link-wrap">
            <a
              href={contactObj.url[lang]}
              target="_blank"
              rel="noopener noreferrer"
              className="axa-goal-support-help-link"
            >
              {contactObj.url[lang]}
            </a>
          </div>
        )}
      </div>
    );
  }

  getList = () => {
    switch (this.props.type) {
      case 'my-wellness':
        return [
          {
            text: t('MY_WELLNESS_SUPPORT_RULES'),
            link: 'aktivo-onboarding/my-wellness/rules',
            isShow: true,
            onClick: () => {
              goto('aktivo-onboarding/my-wellness/rules');
            },
          },
          {
            text: t('AXA_GOAL_SUPPORT_TRACKING_DEVICE'),
            link: 'aktivo-onboarding/tracker',
            isShow: isApp(),
          },
        ];
      case 'axa-goal':
      default: {
        let ruleLink = 'emma-vhis/rules';
        if (this.props.ruleType) {
          if (this.props.ruleType === 'SH') {
            ruleLink = 'emma-vhis/rules/sh';
          }
          if (this.props.ruleType === 'WGP') {
            ruleLink = 'emma-vhis/rules/wgp';
          }
        }
        return [
          {
            text: t('AXA_GOAL_SUPPORT_RULES'),
            link: ruleLink,
            isShow: true,
            onClick: () => {
              goto(ruleLink);
            },
          },
          {
            text: t('AXA_GOAL_SUPPORT_TRACKING_DEVICE'),
            link: 'aktivo-onboarding/tracker',
            isShow: isApp(),
          },
        ];
      }
    }
  };

  getNavTitle = () => {
    switch (this.props.type) {
      case 'my-wellness':
        return t('MY_WELLNESS_SUPPORT_TITLE');
      case 'axa-goal':
      default:
        return t('AXA_GOAL_SUPPORT_TITLE');
    }
  };

  render() {
    const list = this.getList();

    const entityCode = _.get(this.props, 'match.params.entityCode');

    const { lang } = this.props;
    const isShowAllContact = !entityCode;
    const isShowMacau = isShowAllContact || entityCode === ENTITY_CODE.LMA;
    const isShowHk = isShowAllContact || entityCode !== ENTITY_CODE.LMA;
    return (
      <div className="axa-goal-support">
        <div>
          <div className="axa-goal-support-wrap">
            <EmmaNavTitle
              title={this.getNavTitle()}
              component={
                <div className="axa-goal-support-title">
                  {this.getNavTitle()}
                </div>
              }
            />
            <div className="axa-goal-support-mod">
              <div className="axa-goal-support-mod-title">
                {t('AXA_GOAL_SUPPORT_QUESTION')}
              </div>
              <div className="axa-goal-support-mod-content axa-goal-support-mod-content-question">
                {list.map((item: any) => {
                  if (item.isShow) {
                    return (
                      <div
                        className="axa-goal-support-list-item"
                        data-enable-ga
                        data-ga-type="button"
                        onClick={item.onClick || this.goToPage.bind(this, item)}
                      >
                        {item.text}
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            </div>
            <div className="axa-goal-support-mod">
              <div className="axa-goal-support-mod-title">
                {t('AXA_GOAL_SUPPORT_HELP_YOU')}
              </div>
              <div className="axa-goal-support-mod-content axa-goal-support-mod-content-help">
                <div className="axa-goal-support-help">
                  {t('AXA_GOAL_SUPPORT_HELP')}
                </div>
                <div
                  className="axa-goal-support-help-text"
                  dangerouslySetInnerHTML={{
                    __html: memoSanitize(t('AXA_GOAL_SUPPORT_HELP_TEXT')),
                  }}
                ></div>
                {isShowHk &&
                  this.renderContactSession(SUPPORT_CONTACT.HK, lang)}
                {isShowMacau &&
                  this.renderContactSession(SUPPORT_CONTACT.MACAU, lang)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const lang = getLanguage(state);
    return {
      lang,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  Support.mapStateToProps,
  Support.mapDispatchToProps,
)(Support);
